import { IResponseApiFluent, codigosRespuesta } from "../../../../../../Interfaces/base/IResponse";
import { useEffect, useState } from "react";
import UbicacionService from "../../../../../../services/auxiliar/UbicacionService";
import { IUbicacionCommandEliminar } from "../../../../../../Interfaces/auxiliar/IUbicacion";
import { IPanelUbicacionEliminar } from "./PanelUbicacionEliminar";

const UseUbicacionEliminar = (props: IPanelUbicacionEliminar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [contentShow, setcontentShow] = useState(true);
    const [loadprogress, setloadprogress] = useState(false);

    const initial: IUbicacionCommandEliminar = {
        ubicacionId: ""
    }
    const [request, setRequest] = useState<IUbicacionCommandEliminar>(initial)

    const deleteUbicacion = () => {
        setLoading(true)
        UbicacionService.EliminarUbicacion(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setloadprogress(true);
                    setcontentShow(false);
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)

            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    console.log('Error detallado:', e);
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    useEffect(() => {
        if (props.item != initial) {
            setRequest({
                ...request, ubicacionId: props.item.ubicacionId
            })
        }
    }, [props.item])

    return { request, setRequest, deleteUbicacion, loading, reset, mensaje, status,contentShow, loadprogress }

}
export { UseUbicacionEliminar }